import { IconDashboard } from '@tabler/icons';

const dashboard = {
	id: 'dashboard',
	title: 'Dashboard',
	type: 'group',
	children: [
		{
			id: 'dashboard',
			title: 'Dashboard',
			type: 'item',
			url: '/dashboard',
			icon: IconDashboard,
			breadcrumbs: false,
		},
	],
};

export default dashboard;
